import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'agoOfDate',
  standalone: true
})
export class AgoOfDatePipe implements PipeTransform {

  transform(date: string): string {
    const time = new Date(date).getTime();
    const now: any = new Date().getTime();
    const elapsed = now - Number(time);
  
    let result = [];
    const year = Math.floor(elapsed / (1000 * 60 * 60 * 24 * 7 * 4 * 12));
    const month = Math.floor(elapsed % (1000 * 60 * 60 * 24 * 7 * 4 * 12) / (1000 * 60 * 60 * 24 * 7 * 4  ));
    const week = Math.floor(elapsed % (1000 * 60 * 60 * 24 * 7 * 4) / (1000 * 60 * 60 * 24 * 7));
    const day = Math.floor(elapsed % (1000 * 60 * 60 * 24 * 7) / (1000 * 60 * 60 * 24));
    const hour = Math.floor(elapsed % (1000 * 60 * 60 * 24) / (1000 * 60 * 60));
    const minuit = Math.floor(elapsed % (1000 * 60 * 60 ) / (1000 * 60 ));
    const seconds = Math.floor(elapsed % (1000 * 60 ) / 1000);
  
    if (year) result.push(`${year} Year Ago`);
    else if (month) result.push(`${month} Month Ago`);
    else if (week) result.push(`${week} Week Ago`);
    else if (day) result.push(`${day} Day Ago`);
    else if (hour) result.push(`${hour} Hour Ago`);
    else if (minuit) result.push(`${minuit} Minuit Ago`);
    else if (seconds) result.push(`${seconds} seconds Ago`);
    else result.push('Just Now')
  
    return result.join(' - ').split(',').toString();
  }

}
